import { makeBetterEnum } from './betterEnum';

export const GrowthFactor = makeBetterEnum('Headcount', 'Revenue');

export type GrowthFactor = (typeof GrowthFactor)[keyof typeof GrowthFactor];

export const GrowthFactorType = makeBetterEnum(
  'Custom',
  'GrossProfit',
  'Headcount',
  'NightsStayed',
  'Orders',
  'Patients',
  'Revenue',
  'SupplierSpend'
);

export type GrowthFactorType =
  (typeof GrowthFactorType)[keyof typeof GrowthFactorType];
